import { useEffect, useRef, useState } from 'react';
import './activity-logs.styles.scss';
import { off } from 'firebase/database';
import { format } from 'date-fns';
import { getActivityLogs, getAllUsersFromDb } from '@/utils/getAdminData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const AdminActivityLogs = () => {

  const [toDisplay, setToDisplay] = useState(null);
  const [userList, setUserList] = useState(null);
  const [filterData, setFilterData] = useState({})
  const activityRef = useRef();
  const userListRef = useRef();
  const filterDataRef = useRef();
  const userListener = useRef(null);
  const logListener = useRef(null);

  useEffect(() => {
    let timeoutId;
    timeoutId = setTimeout(() => {
      document.getElementById('logs').classList.add('active');
    }, 500)

    async function getRecentLogs() {
      getActivityLogs({
        'callback': logCallback,
        'receiveListener': receiveLogListener
      })
      function receiveLogListener(unsubscribe) {
        logListener.current = unsubscribe;
      }
    }

    async function getUsers() {
      const obj = {
        'callback': function (e) { usersCallback(e) },
        'lastUser': null,
        'receiveListener': function (e) { receiveUserListener(e) },
      }
      getAllUsersFromDb(obj);
      function receiveUserListener(unsubscribe) {
        userListener.current = unsubscribe;
      }
      async function usersCallback(newUser) {
        // console.log(newUser);
        userListRef.current = { ...userListRef.current, ...{ [newUser.appId]: newUser } }
        setUserList(userListRef.current);
      }
    }

    getRecentLogs();
    getUsers();
    changeDocumentTitle('Gamably Admin | User Activity Logs');

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (userListener.current) {
        userListener.current();
      }
      if (logListener.current) {
        off(logListener.current);
      }
    }
  }, [])

  function logCallback(data) {
    // console.log(data);
    activityRef.current = { ...activityRef.current, ...{ [data.ts]: data } }
    setToDisplay(activityRef.current)
  }

  function saveFilterData(key, value) {
    filterDataRef.current = { ...filterDataRef.current, ...{ [key]: value } }
    setFilterData(filterDataRef.current);
  }

  async function filterLogs() {
    if (logListener.current) { off(logListener.current); }
    activityRef.current = null;
    setToDisplay(activityRef.current)
    const filterObj = { ...{ 'callback': logCallback, 'receiveListener': receiveLogListener }, ...filterData }
    console.log(filterObj);
    getActivityLogs(filterObj)
    function receiveLogListener(unsubscribe) {
      logListener.current = unsubscribe;
    }
  }

  return (
    <div className='activity-logs'>
      <div className='section-title'>
        <span>Activity Logs</span>
      </div>
      <div className="g-space-20"></div>
      <div className="filter-row">
        <div className='field'>
          <select className='small' onChange={(e) => saveFilterData('appId', e.target.value)}>
            <option value=''>Choose a user</option>
            {
              (userList) &&
              Object.values(userList).sort((a, b) => (a.lName > b.lName) ? 1 : (a.lName === b.lName) ? ((a.fName > b.fName) ? 1 : -1) : -1)
                .map(user => (
                  <option key={user.appId} value={user.appId}>{user.lName}, {user.fName}</option>
                ))
            }
          </select>
        </div>
        <div className="field">
          <select className='small' onChange={(e) => saveFilterData('type', e.target.value)}>
            <option value=''>Choose a log type</option>
            <option value='error'>Error</option>
            <option value='success'>Success</option>
          </select>
        </div>

        <button className='g-button small-btn primary' onClick={() => filterLogs()}>Filter Results<FontAwesomeIcon icon={faFilter} /></button>
      </div>
      <div className="g-space-20"></div>
      <table className='g-table logs-table'>
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Type</th>
            <th>Function</th>
            <th>Message</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {
            (toDisplay && userList) &&
            Object.values(toDisplay).sort((a, b) => a.ts < b.ts ? 1 : -1)
              .map(a => {
                return (
                  <tr key={a.ts}>
                    <td>{format(new Date(a.ts), 'Pp')}</td>
                    <td>{userList[a.user] ? `${userList[a.user].fName} ${userList[a.user].lName}` : a.user}</td>
                    <td>{a.type}</td>
                    <td>{a.functName}</td>
                    <td>{a.message ?? a.action}</td>
                    <td>{
                      (typeof a.data === 'object')
                        ?
                        Object.keys(a.data).map(k => (
                          <div key={k}>
                            <span>
                              <b>{k}: </b>{a.data[k].toString()}
                            </span><br />
                          </div>
                        ))
                        :
                        a.data ?? null}</td>
                  </tr>
                )
              })

          }
        </tbody>
      </table>

    </div>
  )
}

export default AdminActivityLogs;